module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-3-9"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("CHAPTER 9")])])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "89840.png",
      "src": "OEBPS/image/89840.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("After Ellie’s phone call, I kept wondering what news Sharla Lee had for me. Why had I agreed to have dinner with John? I had muffins to bake and other details to attend to! A text from Jack came up on my phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "textmessage"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("It was just like Jack to be so thoughtful. I quickly changed my clothes before John called. I was putting on lipstick when my cell phone rang.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Cocktails are being served on the first floor, and I don’t want you to miss out,” John teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You were supposed to call when dinner was ready, not cocktails!” I teased back.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Sorry. I already poured the wine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’ll be right down!” I said, hanging up.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("When I walked into John’s condo, I was even more impressed than last time. His table was elegantly set with lit candles which sent a signal of romantic expectations.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“How lovely, Mr. Baker,” I observed as he handed me a glass of wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“To happiness and good health for all,” John toasted.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I thought of Carla.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Hear, hear,” I cheered, raising my glass. “What’s for dinner? It smells so good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“It’s my quick Swiss and American steak. It’s one of my fastest go-to dinners to accommodate you and your tight schedule.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Awesome! Are there mashed potatoes?” I inquired playfully. “You have to have mashed potatoes. It’s the German way!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Of course,” he grinned.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Seriously? Yum! Let’s eat!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Can’t you just relax for a minute? I want to hear all about your aunt’s house and any other news from Borna before we chow down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I was more than happy to catch John up on the news from Borna. I knew he sincerely loved his visit there, and I enjoyed hearing about his travels and what he was writing. I felt a bit envious of his career, and when he talked I felt I was traveling with him. As the conversation progressed, dinner was served and the hours passed by swiftly. The food was delicious and John’s love for cooking showed.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I looked at my watch and it was already nearly ten. “I must go, John. I hate to leave you with all this to clean up, but I still need to bake muffins. If you let me go, I promise to share some of them with you for tomorrow’s breakfast.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("He gave me that magic smile. “I was hoping so. You make the best muffins around! Please go ahead and get your preparations done, but if I start smelling something delicious, I may have to come up and check it out!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Don’t you dare!” I warned. “Thanks for an awesome dinner.” I blew him a kiss and headed up the stairs to my place.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Once there, I turned on the TV for company and changed my clothes. After the two glasses of wine that I had enjoyed earlier, I had to work to stay alert. Once I got started with the process, I realized that I could make these muffins in my sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("John did not knock on my door, but I could hear some of his classical music floating up the stairs as I settled into bed. It made me smile. I prayed for Carla and drifted off to sleep that night with positive thoughts.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame4",
    attrs: {
      "alt": "98998.png",
      "src": "OEBPS/image/98998.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "textmessage"
  }, [_c('span', {
    staticClass: "textmessage1"
  }, [_vm._v("Hope all goes well with Carla tomorrow. Let me know ASAP about her results. Tell Maggie and Mark hello. XOXO, Jack.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432f9e4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/everlastingquilts_split11.vue
// module id = 93
// module chunks = 0